// 全体の親
import ContractOrder from "@/pages/contractChatOrder/Index";

// ChatLuckサービス内容入力
import ContractChatOrder from "@/pages/contractChatOrder/ContractChatOrder";
import ContractChatConfirm from "@/pages/contractChatOrder/ContractChatConfirm";

// システムエラー
import SystemError from "@/pages/SystemError";

export default {
  path: "/contract_order",
  component: ContractOrder,
  children: [
    {
      path: "contract_chat_order",
      name: "ContractChatOrder",
      component: ContractChatOrder,
      props: true,
    },
    {
      path: "contract_chat_confirm",
      name: "ContractChatConfirm",
      component: ContractChatConfirm,
      props: true,
    },
    {
      // システムエラー
      path: "system_error",
      name: "ContractChatSystemError",
      component: SystemError,
      meta: {
        currentPage: ""
      },
      props: true,
    },
  ]
}